/**
 * Globalize relies on currency codes defined by ISO 4217, which are three-letter codes.
 * Stripe supports some non-official currencies (crypto) that do not follow that standard.
 * We need to map these currencies to a 3-chars code so Globalize validation does not throw.
 */

const NON_ISO_CURRENCIES = ['USDC', 'USDB'];

const CURRENCY_MAPPINGS = NON_ISO_CURRENCIES.reduce((map, code, index) => {
  const letter = String.fromCharCode('a'.charCodeAt(0) + index);

  // We use ZZ prefix to generate valid ISO codes as this group of characters is not in use for any other currency.
  map[code] = `ZZ${letter}`;

  return map;
}, Object.create(null));

export default function getCurrencyISOCode(currencyCode: string) {
  const upperCasedCurrencyCode = currencyCode.toUpperCase();

  if (CURRENCY_MAPPINGS[upperCasedCurrencyCode]) {
    return CURRENCY_MAPPINGS[upperCasedCurrencyCode].toUpperCase();
  }

  return upperCasedCurrencyCode;
}
